import * as React from "react";

function Low(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      fill="#686c72"
      {...props}
    >
      <path d="M19.5 5.5v13h-2v-13h2m-7 5v8h-2v-8h2M21 4h-5v16h5V4m-7 5H9v11h5V9m-7 5H2v6h5v-6z" />
    </svg>
  );
}

export default Low;
